var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarProviderMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 14.9141H17.9143C18.3246 14.9141 18.6997 15.1459 18.8832 15.5129L19.9666 17.6796C20.3267 18.3999 19.8029 19.2474 18.9976 19.2474H11.0005M11.0005 14.9141H4.08667C3.67634 14.9141 3.30122 15.1459 3.11771 15.5129L2.03438 17.6796C1.67422 18.3999 2.19801 19.2474 3.00334 19.2474H11.0005M11.0005 14.9141V19.2474M7.93667 1.91406C8.38282 3.17635 9.58667 4.08073 11.0017 4.08073C12.4168 4.08073 13.6207 3.17635 14.0668 1.91406M11.0005 8.41406V9.4974M18.5838 1.91406H19.6671M2.3338 1.91406H3.41714M5.5838 6.51823L4.7713 7.33073M16.4171 6.51823L17.2296 7.33073",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarProviderMenu);
export default __webpack_public_path__ + "static/media/solar-provider-menu.07dfad2b6dbe6e6f08c0add101289b18.svg";
export { ForwardRef as ReactComponent };